import { Edit, SimpleForm } from "react-admin";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import SaveForm from "./SaveForm";
import BackButtonToolbar from "features/BackButtonToolbar";

const EditInternships = () => {
  return (
    <Edit
      title="Редакция на стаж"
      mutationMode="pessimistic"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
        <SaveForm />
      </SimpleForm>
    </Edit>
  );
};
export default EditInternships;
